module.exports = __webpack_public_path__ + "img/contact_banner.8d6f315a.jpg";